export default {
  All: 'all',
  DoNotReorder: 'definedAsDoNotReorder',
  ReOrder: 'notDefinedAsDoNotReorder',
}
